export default __webpack_public_path__ + "static/media/emptyydata-resource.7ccac6f0.png";